// extracted by mini-css-extract-plugin
export var arrow = "section-bread-crumbs-module--arrow--jajtF";
export var breadcrumbsContainer = "section-bread-crumbs-module--breadcrumbs-container--G5Isb";
export var div = "section-bread-crumbs-module--div--0eDDB";
export var link = "section-bread-crumbs-module--link--tI7yS";